import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import {
  AutoCompleteCompleteEvent,
  AutoCompleteModule,
} from 'primeng/autocomplete';
import { GoogleService } from 'src/app/auth/services/google-service/google.service';
import { SectionValidationService } from 'src/app/trip-calculator/services/section-validation.service';
import { TransportFormService } from 'src/app/trip-calculator/services/transport-form.service';
import { ErrorComponent } from '../../../error/error.component';
import { GoogleAutoCompleteResponse } from 'src/app/trip-calculator/models/api-response';

@Component({
  selector: 'app-select-address',
  templateUrl: './select-address.component.html',
  imports: [
    AutoCompleteModule,
    ReactiveFormsModule,
    TranslocoPipe,
    CommonModule,
    ErrorComponent,
  ],
})
export class SelectAddressComponent {
  googleService = inject(GoogleService);
  transportFormService = inject(TransportFormService);
  sectionValidationService = inject(SectionValidationService);
  @Input() formGroup!: FormGroup;
  @Input() placeholder!: string;
  /** Accessible name for the field when no visible label is shown. */
  @Input() ariaLabel?: string;
  /** Id set on the inner input, so an external label/for can target it. */
  @Input() inputId?: string;
  filteredAddress: string[] = [];
  selectedAddress?: string;

  filterAddress(event: AutoCompleteCompleteEvent): void {
    const input = event.query;
    this.googleService.getAutocomplete(input).subscribe({
      next: (response: GoogleAutoCompleteResponse) => {
        this.filteredAddress = response.data
          ? response.data.predictions.map(
              (prediction) => prediction.description,
            )
          : [];
      },
      error: (error) => {
        console.error('Failed to fetch address suggestions:', error);
      },
    });
  }
  // PrimeNG v.19 doesnt manage invalid state on autocomplete forms. This issue is fixed on v.20
  // We can change this when we'll do the migration
  get invalid(): boolean {
    const control = this.formGroup.get('address');
    if (!control || !control.errors) return false;
    const valueNotEmpty = control.value !== null && control.value !== '';
    const interacted = control.dirty || control.touched;
    return interacted || valueNotEmpty;
  }
}
